import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { ResortTypeList } from 'widgets/tour/resort-type-list'

import calendarTour from 'entities/tour/models/calendar-tour/calendar-tour'
import searchTour from 'entities/tour/models/search-tour/search-tour'

import { TownTo } from 'shared/api/tours/search'
import { HeaderGoBack } from 'shared/ui/header-go-back'

const ResortTypePage = observer(() => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const direction = searchTour.getEditableDataForSearchTour()

  const onContinue = (selectedResorts: TownTo[]) => {
    searchTour.setDirectionResort(selectedResorts)
    calendarTour.clearPrice()

    navigate(-2)
  }

  return (
    <div className="container">
      <HeaderGoBack
        buttonWhite
        variant="grey"
        title={direction?.country?.name || t('tours')}
      />

      <ResortTypeList
        selected={direction?.resorts}
        listResorts={direction?.country?.cities}
        onContinue={onContinue}
      />
    </div>
  )
})

export default ResortTypePage
